import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0d91361f")

_pushScopeId("data-v-0d91361f")
const _hoisted_1 = { class: "pa-4" }
const _hoisted_2 = { class: "pa-4 d-flex items-center " }
const _hoisted_3 = {
  class: "d-flex flex-column justify-center items-center circle-slot",
  style: {"height":"100%"}
}
const _hoisted_4 = { class: "flex-1 d-flex flex-column justify-center ml-12" }
const _hoisted_5 = { class: "time" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "d-flex mt-4" }
const _hoisted_8 = { class: "time small" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "mx-2" }, " —— ", -1)
const _hoisted_11 = { class: "time small" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = {
  key: 1,
  class: "flex-1 d-flex flex-column justify-center"
}
const _hoisted_14 = { class: "time" }
const _hoisted_15 = { class: "label" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_circle = _resolveComponent("van-circle")
  const _component_my_card_body = _resolveComponent("my-card-body")
  const _component_my_card = _resolveComponent("my-card")

  return (_openBlock(), _createBlock(_component_my_card, null, {
    header: _withId(() => [
      _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$filter.format($props.currDate)), 1)
    ]),
    default: _withId(() => [
      _createVNode(_component_my_card_body, null, {
        default: _withId(() => [
          _createVNode("div", _hoisted_2, [
            ($props.analysis.reportFlag === 1)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_van_circle, {
                    "current-rate": $props.analysis.sleepScore,
                    "layer-color": "rgba(255,255,255,.05)",
                    color: $setup.scoreFormat($props.analysis.sleepScore).style,
                    size: "100",
                    "stroke-width": "100"
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_3, [
                        _createVNode("div", {
                          style: { color: $setup.scoreFormat($props.analysis.sleepScore).style },
                          class: "score-content"
                        }, _toDisplayString($props.analysis.sleepScore), 5),
                        _createVNode("p", {
                          style: { color: $setup.scoreFormat($props.analysis.sleepScore).style }
                        }, _toDisplayString($setup.scoreFormat($props.analysis.sleepScore).desc), 5)
                      ])
                    ]),
                    _: 1
                  }, 8, ["current-rate", "color"]),
                  _createVNode("div", _hoisted_4, [
                    _createVNode("div", null, [
                      _createVNode("div", _hoisted_5, [
                        _createTextVNode(_toDisplayString($setup.duration($props.analysis.duration).hours) + " ", 1 /* TEXT */),
                        _createVNode("span", null, _toDisplayString(_ctx.$t("scoreAnalyse.hours")), 1),
                        _createTextVNode(" " + _toDisplayString($setup.duration($props.analysis.duration).minutes) + " ", 1 /* TEXT */),
                        _createVNode("span", null, _toDisplayString(_ctx.$t("scoreAnalyse.minutes")), 1)
                      ]),
                      _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("scoreAnalyse.sleepDuration")), 1)
                    ]),
                    _createVNode("div", _hoisted_7, [
                      _createVNode("div", null, [
                        _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$filter.format($props.analysis.fallsleepTimeStamp * 1000, "HH:mm")), 1),
                        _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("scoreAnalyse.fallAsleep")), 1)
                      ]),
                      _hoisted_10,
                      _createVNode("div", null, [
                        _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$filter.format($props.analysis.wakeupTimeStamp * 1000, "HH:mm")), 1),
                        _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("scoreAnalyse.wakeUp")), 1)
                      ])
                    ])
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : ($props.analysis.reportFlag === 2)
                ? (_openBlock(), _createBlock("div", _hoisted_13, [
                    _createVNode("div", null, [
                      _createVNode("div", _hoisted_14, [
                        _createTextVNode(_toDisplayString($setup.duration($props.summary.recordCount).hours) + " ", 1 /* TEXT */),
                        _createVNode("span", null, _toDisplayString(_ctx.$t("scoreAnalyse.hours")), 1),
                        _createTextVNode(" " + _toDisplayString($setup.duration($props.summary.recordCount).minutes) + " ", 1 /* TEXT */),
                        _createVNode("span", null, _toDisplayString(_ctx.$t("scoreAnalyse.minutes")), 1)
                      ]),
                      _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("scoreAnalyse.durationInBed")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})